import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth/authcontext";
import { Button, Col, Flex, Form, Input, Popconfirm, Row, InputRef } from "antd";
import EditorCard from "../content/editorCard";
import { DeleteOutlined } from "@ant-design/icons";
import { Notification } from "../content/notification";
import { RefObject } from "react";
import { createMenuAddOnGroup, updateMenuAddOnGroup} from "../../services/menuaddonservice";

interface AddOnGroupPropertiesProps {
  selectedMaogGuid: string;
  selectedMaogName: string;
  selectedMaogDisplayName: string;
  isShowMenuAddOnGroupProperties: boolean;
  setSelectedMaogGuid: (guid: string) => void;
  setIsChangeMenuAddOnGroup: (flag: string) => void;
  setIsShowMenuAddOnGroupProperties: (flag: string) => void;
  inputRefGroupName: RefObject<InputRef | null>;
}

const AddOnGroupProperties: React.FC<AddOnGroupPropertiesProps> = (props) => {
  const { isReadOnly } = useAuth();
  const [isWarnGroupName, setIsWarnGroupName] = useState(false);
  const [isWarnGroupDisplayName, setIsWarnGroupDisplayName] = useState(false);
  const [selectedMaogNameLocal, setSelectedMaogNameLocal] = useState("");
  const [selectedMaogDisplayNameLocal, setSelectedMaogDisplayNameLocal] = useState("");
  const [skipOnInsert, setSkipOnInsert] = useState(false);
  const { userId: userGuid } = useAuth();

  useEffect(() => {
    if (!skipOnInsert) {
      setSelectedMaogNameLocal(props.selectedMaogName);
      setSelectedMaogDisplayNameLocal(props.selectedMaogDisplayName);
      
    }
  }, [props.isShowMenuAddOnGroupProperties, props.selectedMaogGuid]);

  const handleMaogNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedMaogNameLocal(e.target.value);
    if (e.target.value !== "") {
      setIsWarnGroupName(false);
      
    }
  };

  const handleMoagDisplayNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedMaogDisplayNameLocal(e.target.value);
    if (e.target.value !== "") {
      setIsWarnGroupDisplayName(false);
    }
  };

  const handleSaveMenuAddOnGroup = async () => {
    let isvalid = true;

    if (selectedMaogNameLocal === "") {
      setIsWarnGroupName(true);
      isvalid = false;
    }

    if (selectedMaogDisplayNameLocal === "") {
      setIsWarnGroupDisplayName(true);
      isvalid = false;
    }

    if (isvalid) {
      if (props.selectedMaogGuid === "") {
        const payload = {
          Name: selectedMaogNameLocal,
          DisplayName: selectedMaogDisplayNameLocal,
          Active: true,
          CreatedBy:  userGuid ?? ''
        };

        const response = await createMenuAddOnGroup(payload);
        const status = response.status;

        if (status === 201) {
          Notification("success", "Success", "Group Created");
          setSkipOnInsert(true);
          props.setSelectedMaogGuid(response.data.guid);
          props.setIsChangeMenuAddOnGroup("true");
        }
      } else {
        const payload = {
          Guid: props.selectedMaogGuid,
          Name: selectedMaogNameLocal,
          DisplayName: selectedMaogDisplayNameLocal,
          Active: true,
        };

        const response = await updateMenuAddOnGroup(payload);

        if (response.status === 200) {
          Notification("success", "Success", "Group Add On Properties Updated");
          props.setIsChangeMenuAddOnGroup("true");
        } else {
          Notification("error", "Error", "Error Updating Group Properties");
        }
      }
    }
  };

  const handleDeleteMenuAddOnGroup = async () => {
    try {
      await updateMenuAddOnGroup({
        Guid: props.selectedMaogGuid,
        Name: selectedMaogNameLocal,
        DisplayName: selectedMaogDisplayNameLocal,
        Active: false,
      });
  
      Notification("success", "Success", "Add On Deleted");
  
      resetAddOnProperties();
      props.setSelectedMaogGuid("");
  
    } catch (error) {
      console.error("Error deleting add-on group:", error);
      Notification("error", "Error", "Error Deleting Add On Group");
    } finally {
      props.setIsChangeMenuAddOnGroup("true");
      props.setIsShowMenuAddOnGroupProperties("false");
    }
  };  

  const resetAddOnProperties = () => {
    setSelectedMaogNameLocal("");
    setSelectedMaogDisplayNameLocal("");

    if (props.inputRefGroupName.current) {
      props.inputRefGroupName.current.focus();
    }
  };

  const DeleteOptionGroup = () => {
    if (isReadOnly) return <></>;
    if (props.selectedMaogGuid !== "") {
      return (
        <Popconfirm
          title="Delete Option Group"
          description="Are you sure you want to remove this add-on group from all Menu items that are currently assigned, delete all add-ons, and the group?"
          onConfirm={handleDeleteMenuAddOnGroup}
          okText="Yes"
          cancelText="No"
        >
          <Button
            danger
            size="small"
            style={{ marginLeft: "auto", fontSize: "12px" }}
            icon={<DeleteOutlined />}
          >
            Delete Group
          </Button>
        </Popconfirm>
      );
    } else {
      return <></>;
    }
  };

  return (
    <EditorCard title="Add-On Group Properties">
      <Form name="AddOnGroupProperties" layout="vertical">
        <Flex gap="middle" vertical>
          <Flex gap="middle">
            <label>Name:</label>
            <Input
              value={selectedMaogNameLocal}
              placeholder="Group Name"
              required
              ref={props.inputRefGroupName}
              onChange={handleMaogNameChange}
              style={{
                borderWidth: "1px",
                borderStyle: "solid",
                borderRadius: "8px 0 0 8px",
                width: "20%",
                fontSize: "14px",
              }}
            />
            {isWarnGroupName && (
              <span style={{ color: "red" }}>Group Name is Required.</span>
            )}
          </Flex>
          <Flex gap="middle">
            <label>Kiosk Text:</label>
            <Input
              value={selectedMaogDisplayNameLocal}
              onChange={handleMoagDisplayNameChange}
              placeholder="Display Name"
              style={{
                borderWidth: "1px",
                borderStyle: "solid",
                borderRadius: "8px 0 0 8px",
                width: "20%",
                fontSize: "14px",
              }}
            />
            {isWarnGroupDisplayName && (
              <span style={{ color: "red" }}>
                Kiosk Text is Required. What would you like the customer to see above the options shown on the kiosk?
              </span>
            )}
          </Flex>
          <Row>
            <Col span={20}>
              {!isReadOnly && (
                <Button
                  color='green'
                  variant='solid'
                  size='small'
                  style={{
                    marginTop: '20px',
                    paddingInline: '15px',
                    fontSize: '12px',
                    width: '100'
                  }}

                  onClick={handleSaveMenuAddOnGroup}
                >Save Changes
                </Button>
              )}
            </Col>
            <Col span={3}>{DeleteOptionGroup()}</Col>
          </Row>
        </Flex>
      </Form>
    </EditorCard>
  );
};

export default AddOnGroupProperties;